//START GENAI@GHCOPILOT
import * as z from 'zod';

//START GENAI@GHCOPILOT
//START GENAI@CHATGPT4
const TransactionAmount = z.object({
  //START GENAI@GHCOPILOT
  transactionAmount: z.union([
    z
      .string()
      .max(18)
      .refine(val => !isNaN(parseFloat(val)), {
        message: 'transactionAmount must be a valid number'
      }),
    z.number().refine(val => val.toString().length <= 18, {
      message: 'The transactionAmount cannot exceed 18 characters, including the decimal point'
    })
  ]),
  //END GENAI@CHATGPT4
  transactionCurrencyCode: z.string().length(3)
});
//END GENAI@CHATGPT4

const AddressPreference = z.enum(['NONE', 'FULL', 'POSTAL_COUNTRY']).optional();

const DynamicDataType = z
  .enum([
    'CARD_APPLICATION_CRYPTOGRAM_LONG_FORM',
    'DYNAMIC_CARD_SECURITY_CODE',
    'NONE',
    'CARD_SECURITY_CODE',
    'CARDHOLDER_AUTHENTICATION_CRYPTOGRAM',
    'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM'
  ])
  .optional();

const PaymentOptions = z.object({
  dynamicDataType: DynamicDataType.optional(),
  dpaDynamicDataTtlMinutes: z.union([z.string(), z.number()]).optional()
});

const AuthenticationMethod = z.unknown().array().optional();

const PayloadRequested = z.enum(['AUTHENTICATED', 'NON_AUTHENTICATED']).optional();

const AuthenticationPreferences = z.object({
  authenticationMethods: AuthenticationMethod.optional(),
  payloadRequested: PayloadRequested.optional(),
  supressChallenge: z.boolean().optional()
});

const RecurringData = z.object({
  recurringAmount: z.string().max(48).optional(),
  recurringCurrency: z.string().length(3).optional(),
  recurringDate: z.string().length(8).optional(),
  recurringExpiry: z.string().length(8).optional(),
  recurringExponent: z.string().length(1).optional(),
  recurringFrequency: z.string().max(4).optional(),
  recurringInd: z.object({}).optional()
});

export const DpaTransactionOptionsModel = z.object({
  acquirerBIN: z.string().max(11).optional(),
  acquirerMerchantId: z.string().max(35).optional(),
  authenticationPreferences: AuthenticationPreferences.optional(),
  //START GENAI@GHCOPILOT
  consumerEmailAddressRequested: z.boolean().optional(),
  consumerNameRequested: z.boolean().optional(),
  consumerNationalIdentifierRequested: z.boolean().optional(),
  consumerPhoneNumberRequested: z.boolean().optional(),
  //END GENAI@GHCOPILOT
  customInputData: z.any().optional(),
  dpaAcceptedBillingCountries: z.array(z.string()).optional(),
  dpaAcceptedShippingCountries: z.array(z.string()).optional(),
  dpaBillingPreference: AddressPreference.optional(),
  dpaLocale: z.string().optional(),
  dpaShippingPreference: AddressPreference.optional(),
  merchantCategoryCode: z.string().length(4).optional(),
  merchantCountryCode: z.string().length(2).optional(),
  merchantName: z.string().max(40).optional(),
  merchantOrderId: z.string().max(255).optional(),
  //START GENAI@GHCOPILOT
  payloadTypeIndicator: z.enum(['FULL', 'NONE', 'SUMMARY']).optional(),
  //END GENAI@GHCOPILOT
  paymentOptions: z.array(PaymentOptions).optional(),
  recurringData: RecurringData.optional(),
  transactionAmount: TransactionAmount.optional()
});

//END GENAI@GHCOPILOT

export const InitDataModel = z.object({
  dpaTransactionId: z.string().optional(),
  dpaTransactionOptions: DpaTransactionOptionsModel.optional()
});
//END GENAI@GHCOPILOT
